import React from 'react'
import AppPublishStatusView from '../AppPublishStatusView'
import statusSrc from './status.svg'

const AppUnderReview = () => (
  <AppPublishStatusView
    title="Under Review"
    description="Your app has been successfully submitted for review! We’ll send you an email when we’re done. Check out our submissions guidelines for more information, and if you have any questions, feel free to talk to us!"
    iconSrc={statusSrc}
  />
)

export default AppUnderReview
